import './styles.styl'
import React from 'react'
import SettingsBasic from './settings-basic'
import SettingsWebshop from './settings-webshop'
import SettingsBranding from './settings-branding'
import SettingsEmail from './settings-email'
import SettingsPayment from './settings-payment'
import SettingsBudget from './settings-budget'
import SettingsUsers from './settings-users'
import SettingsCredits from './settings-credits'

export default class CreateProject extends React.Component {
  constructor (props) {
    super(props)

    const project = { ...props.project }
    const settings = (project.hasOwnProperty('settings') && typeof project.settings === 'object') ? project.settings : {}

    this.state = {
      project,
      sectionsOpen: [project.hasOwnProperty('step') ? project.step : 0],
      saving: false,
      basicSettings: settings.hasOwnProperty('basicSettings') ? settings.basicSettings : null,
      webshopSettings: settings.hasOwnProperty('webshopSettings') ? settings.webshopSettings : null,
      brandingSettings: settings.hasOwnProperty('brandingSettings') ? settings.brandingSettings : null,
      emailSettings: settings.hasOwnProperty('emailSettings') ? settings.emailSettings : null,
      paymentSettings: settings.hasOwnProperty('paymentSettings') ? settings.paymentSettings : null,
      rehydrated: (props.customersFetched && props.projectsFetched),
      // budgetSettings: settings.hasOwnProperty('budgetSettings') ? settings.budgetSettings : null,
      // usersSettings: settings.hasOwnProperty('usersSettings') ? settings.usersSettings : null,
      // creditsSettings: settings.hasOwnProperty('creditsSettings') ? settings.creditsSettings : null
    }
  }

  componentWillMount () {
    if (this.props.customersFetched === false && this.props.customersFetching === false) {
      this.props.loadCustomers()
    }

    if (this.props.projectsFetched === false && this.props.projectsFetching === false) {
      this.props.loadProjects()
    }
  }

  componentDidUpdate () {
    if (!this.state.rehydrated && this.props.projectsFetched && this.props.customersFetched) {
      const project = { ...this.props.project }
      const settings = (project.hasOwnProperty('settings') && typeof project.settings === 'object') ? project.settings : {}

      const newState = {
        project,
        sectionsOpen: [project.hasOwnProperty('step') ? project.step : 0],
        saving: false,
        basicSettings: settings.hasOwnProperty('basicSettings') ? settings.basicSettings : null,
        webshopSettings: settings.hasOwnProperty('webshopSettings') ? settings.webshopSettings : null,
        brandingSettings: settings.hasOwnProperty('brandingSettings') ? settings.brandingSettings : null,
        emailSettings: settings.hasOwnProperty('emailSettings') ? settings.emailSettings : null,
        paymentSettings: settings.hasOwnProperty('paymentSettings') ? settings.paymentSettings : null,
        rehydrated: true,
      }

      this.setState(newState)
    }
  }

  saveProgress (navigate = false) {
    if (this.state.project === null) {
      return
    }

    this.setState({ saving: true })
    setImmediate(() => {
      const state = { ...this.state }

      this.props.updateProject(state.project.id, {
        name: state.basicSettings === null ? 'Untitled' : state.basicSettings.projectName || 'Untitled',
        // domains: state.basicSettings === null ? [] : (state.basicSettings.domainName ? [state.basicSettings.domainName] : []),
        domains: Array.isArray(state.domains) ? state.domains : state.basicSettings === null ? [] : (state.basicSettings.domainName ? [state.basicSettings.domainName] : []),
        step: state.sectionsOpen[0],
        settings: {
          basicSettings: {
            ...(state.basicSettings || {}),
            domainName: Array.isArray(state.domains) && state.domains.length ? state.domains[0] : state.basicSettings.domainName || '',
          },
          webshopSettings: state.webshopSettings,
          brandingSettings: state.brandingSettings,
          emailSettings: state.emailSettings,
          paymentSettings: state.paymentSettings
          // budgetSettings: state.budgetSettings,
          // creditsSettings: state.creditsSettings
        }
      }).then(updated => {
        this.setState({ saving: false })
        
        if (navigate === true) {
          this.props.navigateTo(`/projects?status=${state.project.status || 'production'}`)
        }
      })
    })
  }

  closeAllSections () {
    this.setState({ sectionsOpen: [] })
  }

  closeSection (index) {
    const state = { ...this.state }

    if (state.sectionsOpen.indexOf(index) !== -1) {
      state.sectionsOpen.splice(state.sectionsOpen.indexOf(index), 1)
      this.setState({ sectionsOpen: state.sectionsOpen })
    }
  }

  openSection (index) {
    const state = { ...this.state }

    if (state.sectionsOpen.indexOf(index) === -1) {
      state.sectionsOpen.push(index)
      this.setState({ sectionsOpen: state.sectionsOpen })
    }
  }

  toggleSection (index) {
    this.saveProgress()

    if (this.state.sectionsOpen.indexOf(index) === -1) {
      return this.setState({ sectionsOpen: [index] })
    }

    this.closeAllSections()
  }

  nextSection (index) {
    this.saveProgress()
    this.closeSection(index)
    this.openSection(index + 1)
  }

  renderBasicSettings (index) {
    return <SettingsBasic
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      customers={this.props.customers}
      domains={this.state.project.domains}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={{ ...this.state.basicSettings, status: this.state.project.status }}
      save={data => this.setState({ basicSettings: { ...data }, domains: data.domains || [] })}
    />
  }

  renderShopSettings (index) {
    return <SettingsWebshop
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      customers={this.props.customers}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.webshopSettings}
      save={data => this.setState({ webshopSettings: { ...data } })}
      storeType={this.state.basicSettings !== null ? this.state.basicSettings.storeType : 'NONE'}
    />
  }

  renderBrandingSettings (index) {
    const lang = {
      primaryLanguage: '',
      secondaryLanguages: '',
    }

    if (this.state.basicSettings && this.state.basicSettings.primaryLanguage) {
      lang.primaryLanguage = this.state.basicSettings.primaryLanguage
    }

    if (this.state.basicSettings && this.state.basicSettings.secondaryLanguages) {
      lang.secondaryLanguages = this.state.basicSettings.secondaryLanguages
    }

    return <SettingsBranding
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.brandingSettings}
      languages={lang}
      user={this.props.user}
      save={data => {
        // console.log('Setting brandingSettings', data)
        this.setState({ brandingSettings: { ...data } })
      }}
    />
  }

  renderEmailSettings (index) {
    return <SettingsEmail
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.emailSettings}
      save={data => this.setState({ emailSettings: { ...data } })}
    />
  }

  renderPaymentSettings (index) {
    return <SettingsPayment
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.paymentSettings}
      save={data => this.setState({ paymentSettings: { ...data } })}
      close={() => this.saveProgress(true)}
      saving={this.state.saving}
    />
  }

  renderBudgetSettings (index) {
    return <SettingsBudget
      key={index}
      index={index}
      active={(this.state.paymentSettings && typeof this.state.paymentSettings === 'object' && this.state.paymentSettings.budget === true)}
      open={this.state.sectionsOpen.includes(index)}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.budgetSettings}
      save={data => this.setState({ budgetSettings: { ...data } })}
    />
  }

  renderUserSettings (index) {
    return <SettingsUsers
      key={index}
      index={index}
      open={this.state.sectionsOpen.includes(index)}
      nextSection={this.nextSection.bind(this)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.usersSettings}
      save={data => this.setState({ usersSettings: { ...data } })}
    />
  }

  renderCreditsSettings (index) {
    return <SettingsCredits
      key={index}
      index={index}
      active={(this.state.paymentSettings && typeof this.state.paymentSettings === 'object' && this.state.paymentSettings.credits === true)}
      open={this.state.sectionsOpen.includes(index)}
      toggleSection={this.toggleSection.bind(this)}
      data={this.state.creditsSettings}
      save={data => this.setState({ creditsSettings: { ...data } })}
      close={() => this.saveProgress(true)}
      saving={this.state.saving}
    />
  }

  render () {
    const project = this.state.project

    if (!this.state.rehydrated) {
      return <div style={{ textAlign: 'center', marginTop: '100px' }}>Loading...</div>
    }

    const sections = [
      this.renderBasicSettings(0),
      this.renderShopSettings(1),
      this.renderBrandingSettings(2),
      this.renderEmailSettings(3),
      this.renderPaymentSettings(4)
      // this.renderBudgetSettings(5),
      // this.renderUserSettings(6),
      // this.renderCreditsSettings(7)
    ]
  
    if (!project) {
      return this.props.navigateTo('/projects')
    }

    return (
      <div className='page'>
        <header className='header'>
          <div className='container-fluid'>
            <div className='row'>
              <div className='col-12 col-sm-6'>
                <h1>Projecten &raquo; <em>{project.name}</em></h1>
              </div>
              <div className='col-12 col-sm-6 text-align-right'>
                {this.state.saving === false ? <button type='button' className='btn btn-secondary btn-rounded btn-add' disabled><i className='fa fa-floppy-o' /> Opslaan</button> : <button type='button' className='btn btn-secondary btn-rounded btn-add' disabled><i className='fa fa-floppy-o' /> Bezig met opslaan</button>}
              </div>
            </div>
          </div>
        </header>

        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              {sections}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/projects/create/component.js